import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { AnimatedIcon } from '@/components/AnimatedIcon'
import styles from './PromoteToOwnerDialog.module.css'
import { byDesign } from '@/infra/design'
import imgWorkspaceSettingsUrl from '@/assets/misc/img_workspace-settings.svg'
import PortalOverviewProfileIllustration from '@/components/SpotIllustration/PortalOverviewProfileIllustration'

export interface PromoteToOwnerDialogProps {
  showing: boolean
  onClose: () => void
  workspaceName: string
  onPromote: () => void
  isPromotePending: boolean
}

export function PromoteToOwnerDialog({
  showing,
  onClose,
  workspaceName,
  onPromote,
  isPromotePending,
}: PromoteToOwnerDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isPromotePending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />

      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgWorkspaceSettingsUrl}
            illustration={byDesign(
              undefined,
              PortalOverviewProfileIllustration,
            )}
            alt="Illustration of assigning users"
          />
          <ModalSheetContentTitle>
            <span className={styles.titleRow}>
              <AnimatedIcon name="stars" size={28} />
              Promote to Owner
              <AnimatedIcon name="stars" size={28} />
            </span>
          </ModalSheetContentTitle>

          <ModalSheetContentDescription>
            You are about to promote yourself to owner role in{' '}
            <b>{workspaceName}</b>
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            variant="default"
            onPress={onClose}
            isDisabled={isPromotePending}
          />
          <Button
            label="Promote to Owner"
            variant="primary"
            testId="promote-to-owner-confirm-button"
            onPress={onPromote}
            isDisabled={isPromotePending}
            isPending={isPromotePending}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
